<template>
  <div class="card-container">

    <!-- 🔥 BANNER DINÁMICO (PROTEGIDO) -->
    <div class="banner" :style="bannerStyle"></div>

    <!-- 🔥 AVATAR SLOT -->
    <div v-if="$slots.avatar" class="avatar-slot">
      <div class="avatar">
        <slot name="avatar" />
      </div>
    </div>

    <!-- 🔥 BODY -->
    <div class="card-body">
      <slot />
    </div>

  </div>
</template>

<script>
export default {
  name: 'ProfileCard',

  props: {
    banner: {
      type: String,
      default: ''
    }
  },

  computed: {
    bannerStyle() {
      // 🔥 si no hay banner → fallback
      if (!this.banner) {
        return {
          background: 'linear-gradient(135deg, #02162d, #4d9ec1, #36e0f7)'
        }
      }

      // 🔥 si ya es URL completa → usar directo
      if (this.banner.startsWith('http')) {
        return {
          backgroundImage: `url(${this.banner})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }
      }

      // 🔥 limpiar "assets/"
      const cleanPath = this.banner.replace(/^assets\//, '')

      return {
        backgroundImage: `url(${this.$apiImgWeb}/${cleanPath})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }
    }
  }
}
</script>

<style scoped>

.card-container {
  background: #fff;
  border-radius: 16px;
  border: 1px solid #e6e6e6;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.06);
  overflow: visible;
}

.banner {
  width: 100%;
  aspect-ratio: 456 / 190;
  background-repeat: no-repeat;
  position: relative;
  z-index: 1;
}

.banner::after {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.2), transparent);
}

.avatar-slot {
  display: flex;
  justify-content: center;
  margin-top: -100px;
  margin-bottom: 12px;

  position: relative;
  z-index: 10;
}

.avatar {
  width: 116px;
  height: 116px;
  border-radius: 50%;

  background: linear-gradient(135deg, #02162d, #36e0f7);

  display: flex;
  align-items: center;
  justify-content: center;

  color: white;
  font-weight: 700;
  font-size: 28px;

  border: 4px solid #fff;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.12);

  overflow: hidden;
}

.avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
}

.card-body {
  padding: 16px;
}
</style>